<template>
  <div>
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item href="#">系统</Breadcrumb-item>
        <Breadcrumb-item>配置管理</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="btn-wrap">
      <Button type="primary" size="large" :loading="loadingEdit" @click="addParent">新增父级类目</Button>
    </div>
    <div style="margin-top: 10px">
  <Table :columns="parentColumn" :data="parentData" :loading="searchLoading"></Table>
    </div>
    <EditItemModal v-model="editModal" :itemId="itemId" :pid="pid" @on-close="editModal = false" @on-edilllt-success="editSuccess"
                   @on-edit-clearid="clearid"></EditItemModal>
  </div>
</template>
<script>
  import expandRow from './AdminConfigExpand.vue'
  import EditItemModal from './modal/EditItemModal.vue'
  export default {
    components: { expandRow, EditItemModal },
    data () {
      let $constant = this.$constant
      return {
        searchLoading: false,
        reload: 0,
        parentList: [],
        pid: null,
        formRule: {},
        loadingEdit: false,
        editModal: false,
        statusList: $constant.enabledStatus,
        itemList: [],
        itemId: null,
        formData: {
          id: null,
          pid: '',
          title: '',
          descr: '',
          state: '',
          itemType: '',
        },
        parentColumn: [
          {
            type: 'expand',
            width: 50,
            render: (h, params) => {
              let row = params.row
              localStorage.setItem('parentRow', row.id)
              return h(expandRow, {
                props: {
                  row: row
                }
              })
            }
          },
          {
            title: 'id',
            key: 'id',
            align: 'center',
          },
          {
            title: '名称',
            key: 'title',
            align: 'center',
          },
          {
            title: '展现类型',
            align: 'center',
            render: (h, params) => {
              let itemType = params.row.itemType
              let typeEnum = $constant.getEnum($constant.itemType, itemType)
              return h('span', typeEnum && typeEnum.text)
            }
          },
          {
            title: '状态',
            align: 'center',
            render: (h, params) => {
              let status = params.row.state
              let color = status === 0 ? 'red' : ''
              let statusEnum = $constant.getEnum($constant.enabledStatus, status)
              return h('span', {style: {color: color}}, statusEnum && statusEnum.text)
            }
          },
          {
            title: '操作',
            align: 'center',
            render: (h, params) => {
              let self = this
              let row = params.row
              return h('span', [
                h('a', {on: {click: () => self.onEdit(row)}}, '编辑'),
                h('span', ' | '),
                h('a', {on: {click: () => self.addItem(row)}}, '新增子类目'),
              ])
            }
          },
        ],
        parentData: [],
      }
    },
    methods: {
      addParent () {
        this.editModal = true
      },
      getParent () {
        let self = this
        self.$http.get('/adminConfig/getParent').then(function (res) {
          self.parentData = res.data
        })
      },
      editSuccess () {
        this.searchLoading = true
        this.pid = null
        this.getParent()
        this.searchLoading = false
      },
      clearid () {
        this.itemId = null
      },
      onEdit (row) {
        let self = this
        self.editModal = false
        self.itemId = row.id
        self.editModal = true
      },
      addItem (row) {
        this.pid = row.id
        this.editModal = true
      },
      search () {
        this.reload = new Date().getTime()
      },
      onLoading (loading) {
        this.searchLoading = loading
      }
    },
    mounted: function () {
    },
    created: function () {
      this.getParent()
    },
  }
</script>

<style lang="less" scoped>
  .btn-wrap {
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// AdminConfigList.vue?bcc79b38